import { render, staticRenderFns } from "./HomeContact.vue?vue&type=template&id=562fe068&scoped=true&"
import script from "./HomeContact.vue?vue&type=script&lang=js&"
export * from "./HomeContact.vue?vue&type=script&lang=js&"
import style0 from "./HomeContact.vue?vue&type=style&index=0&id=562fe068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562fe068",
  null
  
)

export default component.exports